import { styled } from '@mui/system';
import { Box, Button, Typography } from '@mui/material';
import color from 'src/theme/color';
import gradients from 'src/theme/gradients';

export const ForkContainer = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
    padding: 24px;
    border-radius: 12px;
    background-color: ${color.darkGray};
    margin-top: 16px;
`;

export const ForkText = styled(Typography)`
    font:
        500 14px/18px 'Inter',
        sans-serif;
    color: ${color.white90};
`;

export const ButtonRow = styled(Box)`
    display: flex;
    flex-direction: row;
    gap: 12px;
    align-items: center;
    justify-content: flex-end;
`;

const buttonBase = {
    textTransform: 'none' as const,
    fontFamily: '"Inter",sans-serif',
    fontSize: '14px',
    fontWeight: 600,
    borderRadius: '100px',
    border: 'none',
    boxShadow: 'none',
    padding: '8px 24px',
    '&:hover': { boxShadow: 'none' },
    '&:active': { boxShadow: 'none' }
};

export const SelfAnswerButton = styled(Button)({
    ...buttonBase,
    backgroundColor: color.darkGray,
    color: color.white,
    border: '1px solid rgba(255,255,255,0.18)',
    '&:hover': {
        backgroundColor: '#3a3d4a',
        borderColor: 'rgba(255,255,255,0.32)',
        boxShadow: 'none'
    },
    '&.Mui-disabled': {
        color: color.white40,
        backgroundColor: color.darkGray,
        border: '1px solid rgba(255,255,255,0.18)'
    }
});

export const SendButton = styled(Button)({
    ...buttonBase,
    background: gradients.goldenYellow,
    color: color.white,
    '&:hover': {
        background: gradients.goldenYellow,
        filter: 'brightness(1.1)',
        boxShadow: 'none'
    },
    '&.Mui-disabled': {
        background: 'rgba(255,255,255,0.12)',
        color: 'rgba(255,255,255,0.3)'
    }
});
